import { ParseAdapter } from '../abstract/ParseAdapter';

export class Vehicle extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get class(): string { return this.parseObject.get('class'); }
    set class(value: string) { this.parseObject.set('class', value); }

    get color(): string { return this.parseObject.get('color'); }
    set color(value: string) { this.parseObject.set('color', value); }

    get brand(): string { return this.parseObject.get('brand'); }
    set brand(value: string) { this.parseObject.set('brand', value); }

    get autoComplete(): boolean { return this.parseObject.get('autoComplete'); }
    set autoComplete(value: boolean) { this.parseObject.set('autoComplete', value); }

    get kilometrage(): number { return this.parseObject.get('kilometrage'); }
    set kilometrage(value: number) { this.parseObject.set('kilometrage', value); }

    get capaciteReservoir(): number { return this.parseObject.get('capaciteReservoir'); }
    set capaciteReservoir(value: number) { this.parseObject.set('capaciteReservoir', value); }

    get webObjectId(): string { return this.parseObject.get('webObjectId'); }
    set webObjectId(value: string) { this.parseObject.set('webObjectId', value); }
    get model(): string { return this.parseObject.get('model'); }
    set model(value: string) { this.parseObject.set('model', value); }

    get isDeleted(): boolean { return this.parseObject.get('isDeleted'); }
    set isDeleted(value: boolean) { this.parseObject.set('isDeleted', value); }

    get companyPtr(): Parse.Object { return this.parseObject.get('companyPtr'); }
    set companyPtr(value: Parse.Object) { this.parseObject.set('companyPtr', value); }

    get circulationDate(): Date { return this.parseObject.get('circulationDate'); }
    set circulationDate(value: Date) { this.parseObject.set('circulationDate', value); }

    get categorie(): number { return this.parseObject.get('categorie'); }
    set categorie(value: number) { this.parseObject.set('categorie', value); }

    get toSync(): boolean { return this.parseObject.get('toSync'); }
    set toSync(value: boolean) { this.parseObject.set('toSync', value); }

    get cle(): number { return this.parseObject.get('cle'); }
    set cle(value: number) { this.parseObject.set('cle', value); }

    get numero(): string { return this.parseObject.get('numero'); }
    set numero(value: string) { this.parseObject.set('numero', value); }

    get immat(): string { return this.parseObject.get('immat'); }
    set immat(value: string) { this.parseObject.set('immat', value); }

    get jauge(): number { return this.parseObject.get('jauge'); }
    set jauge(value: number) { this.parseObject.set('jauge', value); }

    get marqueType(): string { return this.parseObject.get('marqueType'); }
    set marqueType(value: string) { this.parseObject.set('marqueType', value); }

    get recordingDate(): Date { return this.parseObject.get('recordingDate'); }
    set recordingDate(value: Date) { this.parseObject.set('recordingDate', value); }

    get vin(): string { return this.parseObject.get('vin'); }
    set vin(value: string) { this.parseObject.set('vin', value); }

    get or(): string { return this.parseObject.get('or'); }
    set or(value: string) { this.parseObject.set('or', value); }
}



// WEBPACK FOOTER //
// ./src/app/model/vehicle.model.ts